<template>
  <Catalog
    title="Источник исполнителя"
    name-label="Название источника"
    submit-error="Укажите название источника исполнителей."
    description-label="Например: Авито, HeadHunter, Рекомендация"
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    :exact-id="createId"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import Catalog from "../Catalog.vue";

export default {
  name: "WorkerSource",
  components: { Catalog },
  mixins: [ catalogs ],
  props: {
    createId: { type: Number }
  },
  methods: {
    async fetchData(id) {
      return await this.getWorkerSourceById(id);
    },
    async putData(data) {
      return await this.putWorkerSource(data)
    },
    async postData(data) {
      return await this.postWorkerSource(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSources/WorkerSource.vue